{
    "IncludeintransitioningsequenceLabel": "In die Anzeigesequenz für den Berichtsübergang einbeziehen:",
    "RptdisplintervaltimeLabel": "Berichtsanzeigeintervallzeit:",
    "RptdisplintervaltimePlaceholder": "5 Sek",
    "DisplaySwitching_SectionHeader": "Automatische Umschaltung der Berichtsanzeige",
    "NAME": "DisplaySwitching"
}